/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const Search = (props) => {
	const { searchY, progress, firstClassName, secondClassName, thirdClassName } = props;
	const colors = useSelector((store) => store?.color);
	const [isBackground, setIsBackground] = useState(false);
	const [isHide, setIsHide] = useState(false);

	useEffect(() => {
		const handleOpen = () => setIsHide(true);
		const handleClose = () => setIsHide(false);

		window.addEventListener('freshchat:open', handleOpen);
		window.addEventListener('freshchat:close', handleClose);

		return () => {
			try {
				window.removeEventListener('freshchat:open', handleOpen);
				window.removeEventListener('freshchat:close', handleClose);
			} catch (error) {
				console.warn('Failed to remove freshchat listeners', error);
			}
		};
	}, []);

	useEffect(() => {
		const handleChange = (event) => {
			setIsBackground(Boolean(event?.detail?.isOpen));
		};

		window.addEventListener('modal:change', handleChange);

		return () => {
			try {
				window.removeEventListener('modal:change', handleChange);
			} catch (error) {
				console.warn('Failed to remove modal:change listener', error);
			}
		};
	}, []);

	if (isHide) return null;

	return (
		<div
			className={`w-[101%] max-w-md fixed z-[1] ${firstClassName}`}
			style={{
				background: progress > 0.95 ? colors?.roseViolet : 'transparent',
				transition: 'background-color .15s ease',
				transform: `translateY(${searchY}px)`,
			}}>
			<div className={`px-4 py-2 ${secondClassName}`}>
				<Link to='/search' id='homepage_search' className={`flex h-[37px] items-center gap-2 rounded-full border border-gray-200 px-3 shadow-[0_2px_6px_rgba(0,0,0,.12)] ${thirdClassName} ${isBackground ? 'bg-transparent' : 'bg-white'}`}>
					<MagnifyingGlassIcon className='h-5 w-5 text-gray-500' />

					<span className={`text-xs ${isBackground ? 'bg-current' : 'text-gray-400'}`}>Mau cari makanan apa?</span>
				</Link>
			</div>
		</div>
	);
};

export default Search;
